(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-my-id', {
                parent: 'entity',
                url: '/stats-my-id?page&search',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN'],
                    pageTitle: 'global.menu.statistics.myID'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-my-id/stats-my-id.html',
                        controller: 'StatsMyIDController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'count(myID.id),desc',
                        squash: true
                    },
                    documentNumber: null,
                    fromDate: null,
                    toDate: null,
                    fromZonedDate: null,
                    toZonedDate: null,
                    firstRun: true
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            documentNumber: $stateParams.documentNumber,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate,
                            fromZonedDate: $stateParams.fromZonedDate,
                            toZonedDate: $stateParams.toZonedDate,
                            firstRun: $stateParams.firstRun,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('transaction');
                        $translatePartialLoader.addPart('myID');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
